import {
  Box,
  Button,
  InputLabel,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import identityInfo from "../../../../../../media/images/icons/identityInfo-icon.svg";
import ArrowDownSVG from "../../../../../../media/images/icons/arrow-down";
import DangerFill from "../../../../../../media/images/icons/danger-fill";
import InfoCircle from "../../../../../../media/images/icons/info-circle";
import CustomInputLabel from "../../../../../components/CustomInputLabel";
import CustomInput from "../../../../../components/CustomInput";
import CustomSelectOption from "../../../../../components/CustomSelectOption";
import EditIconSVG from "../../../../../../media/images/icons/edit-icon";
import CheckCircle from "../../../../../../media/images/icons/check-circle";

export interface Ioption {
  label: string | number;
  value: number;
  disabled?: boolean;
}
export default function IdentityInfo() {
  const [isOpen, setIsOpen] = useState(false);

  const theme = useTheme();

  const [months, setMonths] = useState<Ioption[]>([]);

  const mymonths = [
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
    "دی",
    "بهمن",
    "اسفند",
  ];

  useEffect(() => {
    setMonths(
      mymonths.map((item, index) => ({ label: item, value: index + 1 }))
    );
  }, []);

  const toggleBox = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box
      sx={{
        backgroundColor: "background.default",
        display: "flex",
        flexDirection: "column",
        border: "1px solid gray",
        borderRadius: "10px",
        padding: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          borderBottom: isOpen ? "1px solid gray" : "",
          paddingBottom: isOpen ? "8px" : "",
          transition: "padding 0.2s ease",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "start",
          }}
        >
          <img width={32} src={identityInfo} alt="" />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
              }}
            >
              اطلاعات هویتی
            </Typography>
            <Typography>شماره گواهینامه، تاریخ تولد، تلفن‌همراه</Typography>
          </Box>
        </Box>
        <Button
          onClick={() => toggleBox()}
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid gray",
            minWidth: "0px !important",
            height: "fit-content",
            padding: "10px 8px",
            gap: "4px",
            borderColor: isOpen
              ? `${theme.palette.error.main} !important`
              : `${theme.palette.secondary.main} !important`,
            backgroundColor: isOpen
              ? `${theme.palette.error.light} !important`
              : `${theme.palette.secondary.light} !important`,
            "& .MuiTouchRipple-root": {
              color: `${theme.palette.error.main} !important`,
              borderWidth: "0px !important",
            },
            "& .MuiButtonBase-root": {
              color: `${theme.palette.error.main} !important`,
              borderWidth: "0px !important",
              minWidth: "0px !important",
            },
            "& .MuiButton-root": {
              minWidth: "0px !important",
            },
          }}
        >
          {isOpen ? (
            <Typography
              sx={{
                color: isOpen ? "error.main" : "secondary.main",
                fontSize: "12px",
                fontWeight: "600",
                whiteSpace: "nowrap",
              }}
            >
              بستن جزئیات
            </Typography>
          ) : (
            <Typography
              sx={{
                color: isOpen ? "error.main" : "secondary.main",
                fontSize: "12px",
                fontWeight: "600",
                whiteSpace: "nowrap",
              }}
            >
              مشاهده/ویرایش{" "}
            </Typography>
          )}

          <ArrowDownSVG
            size={14}
            color={
              isOpen ? theme.palette.error.main : theme.palette.secondary.main
            }
          />
        </Button>
      </Box>
      <Box
        sx={{
          overflow: "hidden",
          maxHeight: isOpen ? "1000px" : 0,
          transition: isOpen ? "max-height 0.5s ease" : "max-height 0.2s ease",
          paddingX: "6px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <Box
          sx={{
            mt: 1,
            backgroundColor: "primary.light",
            borderRadius: "8px",
            padding: "6px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <DangerFill color={theme.palette.primary.main} />
            <Typography
              sx={{
                color: "primary.main",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              توجه:
            </Typography>
          </Box>
          <Typography
            sx={{
              color: "primary.main",
            }}
          >
            بعد از تغییر اطلاعات یا ناوگان، حساب شما به حالت احرازنشده تبدیل
            می‌شود و نیاز است دوباره عکس مدارک خود را در بخش مدارک ارسال کنید تا
            احراز هویت کامل شود.{" "}
          </Typography>
        </Box>
        <Box
          sx={{
            flex: "1",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            // border: "1px solid gray",
          }}
        >
          <Box>
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
              }}
            >
              نام و نام‌خانوادگی
            </Typography>
            <Box
              sx={{
                backgroundColor: "info.light",
                textAlign: "center",
                borderRadius: "8px",
                padding: "8px 0px",
              }}
            >
              رضا یعقوبی فریان پور
            </Box>
            <Box
              sx={{
                marginTop: "4px",
                display: "flex",
                gap: "4px",
              }}
            >
              <InfoCircle color={theme.palette.secondary.dark} size={16} />
              <Typography
                sx={{
                  fontSize: "10px",
                  color: "secondary.dark",
                }}
              >
                نام و نام‌خانوادگی قابل تغییر نمی‌باشند، می‌توانید یک ثبت نام
                جدید با مشخصات دیگر انجام دهید.
              </Typography>
            </Box>
          </Box>
          <Box>
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
              }}
            >
              کدملی:{" "}
            </Typography>
            <Box
              sx={{
                backgroundColor: "info.light",
                textAlign: "center",
                borderRadius: "8px",
                padding: "8px 0px",
              }}
            >
              0123456789{" "}
            </Box>
            <Box
              sx={{
                marginTop: "4px",
                display: "flex",
                gap: "4px",
              }}
            >
              <InfoCircle color={theme.palette.secondary.dark} size={16} />
              <Typography
                sx={{
                  fontSize: "10px",
                  color: "secondary.dark",
                }}
              >
                نام و نام‌خانوادگی قابل تغییر نمی‌باشند، می‌توانید یک ثبت نام
                جدید با مشخصات دیگر انجام دهید.
              </Typography>
            </Box>
          </Box>
          {/**licence number */}
          <Box>
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"شماره گواهینامه"}
            </CustomInputLabel>

            <CustomInput
              value={"0123456789"}
              placHolder="شماره گواهینامه راننده را وارد کنید..."
            />
          </Box>
          {/**date of brith */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <InputLabel
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  marginBottom: "8px",
                  fontSize: "14px",
                }}
                htmlFor="outlined-adornment-amount"
              >
                {"سال تولد:"}
              </InputLabel>
              <CustomSelectOption
                selectFor={"year"}
                // handleChange={handleDateOfBrith}
                handleChange={() => console.log()}
                options={new Array(80).fill(1).map((item, index) => ({
                  label: 1300 + index,
                  value: 1300 + index,
                }))}
                // value={formik.values.dateOfBrith.jy}
                value={1352}
              />
            </Box>
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <InputLabel
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  marginBottom: "8px",
                  fontSize: "14px",
                }}
                htmlFor="outlined-adornment-amount"
              >
                {"ماه تولد:"}
              </InputLabel>

              <CustomSelectOption
                selectFor="month"
                handleChange={() => console.log()}
                // handleChange={handleDateOfBrith}
                // value={formik.values.dateOfBrith.jm}
                options={months}
              />
            </Box>
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <InputLabel
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  marginBottom: "8px",
                  fontSize: "14px",
                }}
                htmlFor="outlined-adornment-amount"
              >
                {"روز تولد:"}
              </InputLabel>

              <CustomSelectOption
                selectFor="day"
                handleChange={() => console.log()}
                // value={formik.values.dateOfBrith.jd}
                options={new Array(30).fill(1).map((item, index) => ({
                  label: index + 1,
                  value: index + 1,
                }))}
              />
            </Box>
          </Box>
          {/**change number */}
          <Box>
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"تلفن همراه"}
            </CustomInputLabel>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                border: "1px solid gray",
                borderRadius: "8px",
                padding: "4px",
              }}
            >
              <TextField
                value={"09155555555"}
                placeholder="سوال یا موضوع را جست‌وجو کنید "
                size="small"
                sx={{
                  flex: 1,
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none !important",
                    outline: "none !important",
                  },
                  "& .MuiInputBase-input": {
                    border: "none !important",
                    outline: "none !important",
                  },
                  "& .MuiInputBase-root": {
                    border: "none !important",
                    outline: "none !important",
                  },
                  border: "none",
                }}
              />
              <Button
                // onClick={() => toggleBox()}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid gray",
                  minWidth: "0px !important",
                  borderRadius: "6px",
                  //   gap: "8px",
                  borderColor: `${theme.palette.primary.main} !important`,
                  backgroundColor: `${theme.palette.primary.main} !important`,
                  "& .MuiTouchRipple-root": {
                    color: `#fff !important`,
                    borderWidth: "0px !important",
                  },
                  "& .MuiButtonBase-root": {
                    color: `${theme.palette.primary.main} !important`,
                    borderWidth: "0px !important",
                    minWidth: "0px !important",
                  },
                  "& .MuiButton-root": {
                    minWidth: "0px !important",
                  },
                }}
              >
                <Typography
                  sx={{
                    color: "#fff",
                  }}
                >
                  تغییر شماره همراه{" "}
                </Typography>
                <EditIconSVG size={18} color={"#fff"} />
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: "6px",
            }}
          >
            <InfoCircle color={theme.palette.primary.main} />
            <Typography
              sx={{
                color: "primary.main",
                fontSize: "12px",
              }}
            >
              برای تغییر تلفن همراه ، کد اعتبارسنجی به شماره تلفن همراه شما
              ارسال می‌شود که نیاز است برای احراز شماره تلفن آن را وارد کنید.
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <CheckCircle color={theme.palette.success.main} />
            <Typography
              sx={{
                fontSize: "14px",
                color: "success.main",
              }}
            >
              برای اعمال شدن تغییرات حتما ذخیره اطلاعات را بزنید
            </Typography>
          </Box>

          <Box
            sx={{
              gap: "8px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Button
              onClick={() => toggleBox()}
              sx={{
                flex: "1",
                display: "flex",
                alignItems: "center",
                border: "1px solid gray",
                borderRadius: "6px",
                minWidth: "0px !important",
                //   gap: "8px",
                borderColor: `${theme.palette.primary.main} !important`,
                backgroundColor: `${theme.palette.primary.light} !important`,
                "& .MuiTouchRipple-root": {
                  color: `${theme.palette.primary.main} !important`,
                  borderWidth: "0px !important",
                },
                "& .MuiButtonBase-root": {
                  color: `${theme.palette.primary.main} !important`,
                  borderWidth: "0px !important",
                  minWidth: "0px !important",
                },
                "& .MuiButton-root": {
                  minWidth: "0px !important",
                },
              }}
            >
              <Typography
                sx={{
                  color: "primary.main",
                }}
              >
                انصراف{" "}
              </Typography>
              {/* <ArrowDownSVG size={18} color={theme.palette.error.main} /> */}
            </Button>
            <Button
              //   onClick={() => toggleBox()}
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                borderRadius: "6px",
                border: "1px solid gray",
                minWidth: "0px !important",
                //   gap: "8px",
                borderColor: `${theme.palette.primary.main} !important`,
                backgroundColor: `${theme.palette.primary.main} !important`,
                "& .MuiTouchRipple-root": {
                  color: `#fff !important`,
                  borderWidth: "0px !important",
                },
                "& .MuiButtonBase-root": {
                  color: `${theme.palette.primary.main} !important`,
                  borderWidth: "0px !important",
                  minWidth: "0px !important",
                },
                "& .MuiButton-root": {
                  minWidth: "0px !important",
                },
              }}
            >
              <Typography
                sx={{
                  color: "#fff",
                }}
              >
                ذخیره اطلاعات{" "}
              </Typography>
              {/* <ArrowDownSVG size={18} color={theme.palette.error.main} /> */}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
